import React, { useEffect, useRef } from "react";
import { useState } from "react";

function TextFieldChat({
  placeholder = "Message...",
  value,
  onChange,
  className = "",
  options = [],
  selected_option = "",
  refresh_rows = false,
  setRefreshRows,
  setSelectedOption = () => {},
}) {
  const textAreaRef = useRef(null);
  const [displayOptions, setDisplayOptions] = useState(false);

  const handleInput = (e) => {
    // Reset the height to auto to calculate the correct scrollHeight
    textAreaRef.current.style.height = "auto";
    // Set the height based on scrollHeight, but limit it to 200px
    if (textAreaRef.current.scrollHeight <= 200) {
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      textAreaRef.current.style.overflowY = "hidden"; // Hide vertical scroll
    } else {
      textAreaRef.current.style.height = "200px"; // Set max height
      textAreaRef.current.style.overflowY = "scroll"; // Add vertical scroll when max height is reached
    }
    // Trigger the passed onChange event
    onChange(e);
    // check if last character is '@'
  };

  useEffect(() => {
    if (value.slice(-1) === "@") {
      setDisplayOptions(true);
    } else {
      setDisplayOptions(false);
    }
  }, [value]);

  useEffect(() => {
    if (refresh_rows) {
      setRefreshRows(false);
      handleInput({ target: { value: "" } });
      setDisplayOptions(false);
    }
  }, [refresh_rows]);

  return (
    <div>
      <div className=" z-10 absolute bottom-16 bg-white w-c200 border text-h3 rounded-md shadow-md">
        {displayOptions &&
          options.map((option, index) => (
            <div
              key={index}
              className="p-2 hover:bg-gray-100 cursor-pointer border-b-1 border-shadow_10"
              onClick={() => {
                setDisplayOptions(false);
                setSelectedOption(option.value);
                textAreaRef.current.focus();
                // remove the '@' character
                let e = { target: { value: value.slice(0, -1) } };
                handleInput(e);
              }}
            >
              {option.name}
            </div>
          ))}
      </div>
      <textarea
        ref={textAreaRef}
        value={value}
        onChange={handleInput}
        placeholder={placeholder}
        className={`h-auto max-h-[200px] border-0 w-full p-2 text-sm bg-white text-black rounded-md 
                  focus:outline-none focus:ring-2 focus:ring-indigo-300 
                  placeholder-gray-400 transition duration-300 ease-in-out 
                  resize-none ${className}`}
        rows={1} // Initial row
      />
    </div>
  );
}

export default TextFieldChat;
